import { LogLevel, PublicClientApplication } from "@azure/msal-browser";
import { getEnvConfig } from "@/config/envConfig";

let _msalInstance: any;

// Config object to be passed to Msal on creation
function createConfig(envConfig: any) {
  return {
    auth: {
      clientId: envConfig.appClientId,
      redirectUri: envConfig.authRedirectUri,
      authority: envConfig.appAuthority,
      postLogoutRedirectUri: envConfig.authLogoutRedirectUri
    },
    cache: {
      cacheLocation: "localStorage"
    },
    system: {
      loggerOptions: {
        loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
          if (containsPii) {
            return;
          }
          switch (level) {
            case LogLevel.Error:
              console.error(message);
              return;
            case LogLevel.Info:
            case LogLevel.Verbose:
              console.debug(message);
              return;
            case LogLevel.Warning:
              console.warn(message);
              return;
            default:
              return;
          }
        },
        logLevel: LogLevel.Verbose
      }
    }
  };
}

/**
 * Creates MSAL Singleton instance
 */
export function getMsalInstance() {
  if (_msalInstance) {
    return _msalInstance;
  }
  const config = createConfig(getEnvConfig());
  _msalInstance = new PublicClientApplication(config);
  return _msalInstance;
}

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = {
  scopes: ["User.Read"]
};
